/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthRouteRouteImport } from './routes/_auth/route'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthAdminRouteImport } from './routes/_auth/admin'
import { Route as AuthPlaneRouteImport } from './routes/_auth/plane'
import { Route as AuthTokensRouteImport } from './routes/_auth/tokens'
import { Route as AuthServersIndexRouteImport } from './routes/_auth/servers/index'
import { Route as AuthServersIdRouteRouteImport } from './routes/_auth/servers/$id/route'
import { Route as AuthServersNewRouteImport } from './routes/_auth/servers/new'
import { Route as AuthServersIdIndexRouteImport } from './routes/_auth/servers/$id/index'
import { Route as AuthServersIdActivityRouteImport } from './routes/_auth/servers/$id/activity'
import { Route as AuthServersIdChatRouteImport } from './routes/_auth/servers/$id/chat'
import { Route as AuthServersIdClaudeRouteImport } from './routes/_auth/servers/$id/claude'
import { Route as AuthServersIdGraphRouteImport } from './routes/_auth/servers/$id/graph'
import { Route as AuthServersIdInboxRouteImport } from './routes/_auth/servers/$id/inbox'
import { Route as AuthServersIdPeopleRouteImport } from './routes/_auth/servers/$id/people'
import { Route as AuthServersIdProjectsRouteImport } from './routes/_auth/servers/$id/projects'
import { Route as AuthServersIdQuestionsRouteImport } from './routes/_auth/servers/$id/questions'
import { Route as AuthServersIdServerRouteImport } from './routes/_auth/servers/$id/server'
import { Route as AuthServersIdSourcesRouteImport } from './routes/_auth/servers/$id/sources'
import { Route as AuthServersIdSuggestionsRouteImport } from './routes/_auth/servers/$id/suggestions'
import { Route as AuthServersIdWorkflowRouteImport } from './routes/_auth/servers/$id/workflow'
import { Route as AuthServersIdRunsRidRouteImport } from './routes/_auth/servers/$id/runs.$rid'
import { Route as AuthServersIdTasksKeyRouteImport } from './routes/_auth/servers/$id/tasks.$key'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRouteRoute = AuthRouteRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthAdminRoute = AuthAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthPlaneRoute = AuthPlaneRouteImport.update({
  id: '/plane',
  path: '/plane',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthTokensRoute = AuthTokensRouteImport.update({
  id: '/tokens',
  path: '/tokens',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthServersIndexRoute = AuthServersIndexRouteImport.update({
  id: '/servers/',
  path: '/servers/',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthServersIdRouteRoute = AuthServersIdRouteRouteImport.update({
  id: '/servers/$id',
  path: '/servers/$id',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthServersNewRoute = AuthServersNewRouteImport.update({
  id: '/servers/new',
  path: '/servers/new',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthServersIdIndexRoute = AuthServersIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthServersIdRouteRoute,
} as any)
const AuthServersIdActivityRoute = AuthServersIdActivityRouteImport.update({
  id: '/activity',
  path: '/activity',
  getParentRoute: () => AuthServersIdRouteRoute,
} as any)
const AuthServersIdChatRoute = AuthServersIdChatRouteImport.update({
  id: '/chat',
  path: '/chat',
  getParentRoute: () => AuthServersIdRouteRoute,
} as any)
const AuthServersIdClaudeRoute = AuthServersIdClaudeRouteImport.update({
  id: '/claude',
  path: '/claude',
  getParentRoute: () => AuthServersIdRouteRoute,
} as any)
const AuthServersIdGraphRoute = AuthServersIdGraphRouteImport.update({
  id: '/graph',
  path: '/graph',
  getParentRoute: () => AuthServersIdRouteRoute,
} as any)
const AuthServersIdInboxRoute = AuthServersIdInboxRouteImport.update({
  id: '/inbox',
  path: '/inbox',
  getParentRoute: () => AuthServersIdRouteRoute,
} as any)
const AuthServersIdPeopleRoute = AuthServersIdPeopleRouteImport.update({
  id: '/people',
  path: '/people',
  getParentRoute: () => AuthServersIdRouteRoute,
} as any)
const AuthServersIdProjectsRoute = AuthServersIdProjectsRouteImport.update({
  id: '/projects',
  path: '/projects',
  getParentRoute: () => AuthServersIdRouteRoute,
} as any)
const AuthServersIdQuestionsRoute = AuthServersIdQuestionsRouteImport.update({
  id: '/questions',
  path: '/questions',
  getParentRoute: () => AuthServersIdRouteRoute,
} as any)
const AuthServersIdServerRoute = AuthServersIdServerRouteImport.update({
  id: '/server',
  path: '/server',
  getParentRoute: () => AuthServersIdRouteRoute,
} as any)
const AuthServersIdSourcesRoute = AuthServersIdSourcesRouteImport.update({
  id: '/sources',
  path: '/sources',
  getParentRoute: () => AuthServersIdRouteRoute,
} as any)
const AuthServersIdSuggestionsRoute =
  AuthServersIdSuggestionsRouteImport.update({
    id: '/suggestions',
    path: '/suggestions',
    getParentRoute: () => AuthServersIdRouteRoute,
  } as any)
const AuthServersIdWorkflowRoute = AuthServersIdWorkflowRouteImport.update({
  id: '/workflow',
  path: '/workflow',
  getParentRoute: () => AuthServersIdRouteRoute,
} as any)
const AuthServersIdRunsRidRoute = AuthServersIdRunsRidRouteImport.update({
  id: '/runs/$rid',
  path: '/runs/$rid',
  getParentRoute: () => AuthServersIdRouteRoute,
} as any)
const AuthServersIdTasksKeyRoute = AuthServersIdTasksKeyRouteImport.update({
  id: '/tasks/$key',
  path: '/tasks/$key',
  getParentRoute: () => AuthServersIdRouteRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/admin': typeof AuthAdminRoute
  '/plane': typeof AuthPlaneRoute
  '/tokens': typeof AuthTokensRoute
  '/servers/$id': typeof AuthServersIdRouteRouteWithChildren
  '/servers/new': typeof AuthServersNewRoute
  '/servers/': typeof AuthServersIndexRoute
  '/servers/$id/activity': typeof AuthServersIdActivityRoute
  '/servers/$id/chat': typeof AuthServersIdChatRoute
  '/servers/$id/claude': typeof AuthServersIdClaudeRoute
  '/servers/$id/graph': typeof AuthServersIdGraphRoute
  '/servers/$id/inbox': typeof AuthServersIdInboxRoute
  '/servers/$id/people': typeof AuthServersIdPeopleRoute
  '/servers/$id/projects': typeof AuthServersIdProjectsRoute
  '/servers/$id/questions': typeof AuthServersIdQuestionsRoute
  '/servers/$id/server': typeof AuthServersIdServerRoute
  '/servers/$id/sources': typeof AuthServersIdSourcesRoute
  '/servers/$id/suggestions': typeof AuthServersIdSuggestionsRoute
  '/servers/$id/workflow': typeof AuthServersIdWorkflowRoute
  '/servers/$id/': typeof AuthServersIdIndexRoute
  '/servers/$id/runs/$rid': typeof AuthServersIdRunsRidRoute
  '/servers/$id/tasks/$key': typeof AuthServersIdTasksKeyRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/admin': typeof AuthAdminRoute
  '/plane': typeof AuthPlaneRoute
  '/tokens': typeof AuthTokensRoute
  '/servers/new': typeof AuthServersNewRoute
  '/servers': typeof AuthServersIndexRoute
  '/servers/$id/activity': typeof AuthServersIdActivityRoute
  '/servers/$id/chat': typeof AuthServersIdChatRoute
  '/servers/$id/claude': typeof AuthServersIdClaudeRoute
  '/servers/$id/graph': typeof AuthServersIdGraphRoute
  '/servers/$id/inbox': typeof AuthServersIdInboxRoute
  '/servers/$id/people': typeof AuthServersIdPeopleRoute
  '/servers/$id/projects': typeof AuthServersIdProjectsRoute
  '/servers/$id/questions': typeof AuthServersIdQuestionsRoute
  '/servers/$id/server': typeof AuthServersIdServerRoute
  '/servers/$id/sources': typeof AuthServersIdSourcesRoute
  '/servers/$id/suggestions': typeof AuthServersIdSuggestionsRoute
  '/servers/$id/workflow': typeof AuthServersIdWorkflowRoute
  '/servers/$id': typeof AuthServersIdIndexRoute
  '/servers/$id/runs/$rid': typeof AuthServersIdRunsRidRoute
  '/servers/$id/tasks/$key': typeof AuthServersIdTasksKeyRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_auth': typeof AuthRouteRouteWithChildren
  '/login': typeof LoginRoute
  '/_auth/admin': typeof AuthAdminRoute
  '/_auth/plane': typeof AuthPlaneRoute
  '/_auth/tokens': typeof AuthTokensRoute
  '/_auth/servers/$id': typeof AuthServersIdRouteRouteWithChildren
  '/_auth/servers/new': typeof AuthServersNewRoute
  '/_auth/servers/': typeof AuthServersIndexRoute
  '/_auth/servers/$id/activity': typeof AuthServersIdActivityRoute
  '/_auth/servers/$id/chat': typeof AuthServersIdChatRoute
  '/_auth/servers/$id/claude': typeof AuthServersIdClaudeRoute
  '/_auth/servers/$id/graph': typeof AuthServersIdGraphRoute
  '/_auth/servers/$id/inbox': typeof AuthServersIdInboxRoute
  '/_auth/servers/$id/people': typeof AuthServersIdPeopleRoute
  '/_auth/servers/$id/projects': typeof AuthServersIdProjectsRoute
  '/_auth/servers/$id/questions': typeof AuthServersIdQuestionsRoute
  '/_auth/servers/$id/server': typeof AuthServersIdServerRoute
  '/_auth/servers/$id/sources': typeof AuthServersIdSourcesRoute
  '/_auth/servers/$id/suggestions': typeof AuthServersIdSuggestionsRoute
  '/_auth/servers/$id/workflow': typeof AuthServersIdWorkflowRoute
  '/_auth/servers/$id/': typeof AuthServersIdIndexRoute
  '/_auth/servers/$id/runs/$rid': typeof AuthServersIdRunsRidRoute
  '/_auth/servers/$id/tasks/$key': typeof AuthServersIdTasksKeyRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/admin'
    | '/plane'
    | '/tokens'
    | '/servers/$id'
    | '/servers/new'
    | '/servers/'
    | '/servers/$id/activity'
    | '/servers/$id/chat'
    | '/servers/$id/claude'
    | '/servers/$id/graph'
    | '/servers/$id/inbox'
    | '/servers/$id/people'
    | '/servers/$id/projects'
    | '/servers/$id/questions'
    | '/servers/$id/server'
    | '/servers/$id/sources'
    | '/servers/$id/suggestions'
    | '/servers/$id/workflow'
    | '/servers/$id/'
    | '/servers/$id/runs/$rid'
    | '/servers/$id/tasks/$key'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/admin'
    | '/plane'
    | '/tokens'
    | '/servers/new'
    | '/servers'
    | '/servers/$id/activity'
    | '/servers/$id/chat'
    | '/servers/$id/claude'
    | '/servers/$id/graph'
    | '/servers/$id/inbox'
    | '/servers/$id/people'
    | '/servers/$id/projects'
    | '/servers/$id/questions'
    | '/servers/$id/server'
    | '/servers/$id/sources'
    | '/servers/$id/suggestions'
    | '/servers/$id/workflow'
    | '/servers/$id'
    | '/servers/$id/runs/$rid'
    | '/servers/$id/tasks/$key'
  id:
    | '__root__'
    | '/'
    | '/_auth'
    | '/login'
    | '/_auth/admin'
    | '/_auth/plane'
    | '/_auth/tokens'
    | '/_auth/servers/$id'
    | '/_auth/servers/new'
    | '/_auth/servers/'
    | '/_auth/servers/$id/activity'
    | '/_auth/servers/$id/chat'
    | '/_auth/servers/$id/claude'
    | '/_auth/servers/$id/graph'
    | '/_auth/servers/$id/inbox'
    | '/_auth/servers/$id/people'
    | '/_auth/servers/$id/projects'
    | '/_auth/servers/$id/questions'
    | '/_auth/servers/$id/server'
    | '/_auth/servers/$id/sources'
    | '/_auth/servers/$id/suggestions'
    | '/_auth/servers/$id/workflow'
    | '/_auth/servers/$id/'
    | '/_auth/servers/$id/runs/$rid'
    | '/_auth/servers/$id/tasks/$key'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRouteRoute: typeof AuthRouteRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/admin': {
      id: '/_auth/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AuthAdminRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/plane': {
      id: '/_auth/plane'
      path: '/plane'
      fullPath: '/plane'
      preLoaderRoute: typeof AuthPlaneRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/tokens': {
      id: '/_auth/tokens'
      path: '/tokens'
      fullPath: '/tokens'
      preLoaderRoute: typeof AuthTokensRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/servers/': {
      id: '/_auth/servers/'
      path: '/servers'
      fullPath: '/servers/'
      preLoaderRoute: typeof AuthServersIndexRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/servers/$id': {
      id: '/_auth/servers/$id'
      path: '/servers/$id'
      fullPath: '/servers/$id'
      preLoaderRoute: typeof AuthServersIdRouteRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/servers/new': {
      id: '/_auth/servers/new'
      path: '/servers/new'
      fullPath: '/servers/new'
      preLoaderRoute: typeof AuthServersNewRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/servers/$id/': {
      id: '/_auth/servers/$id/'
      path: '/'
      fullPath: '/servers/$id/'
      preLoaderRoute: typeof AuthServersIdIndexRouteImport
      parentRoute: typeof AuthServersIdRouteRoute
    }
    '/_auth/servers/$id/activity': {
      id: '/_auth/servers/$id/activity'
      path: '/activity'
      fullPath: '/servers/$id/activity'
      preLoaderRoute: typeof AuthServersIdActivityRouteImport
      parentRoute: typeof AuthServersIdRouteRoute
    }
    '/_auth/servers/$id/chat': {
      id: '/_auth/servers/$id/chat'
      path: '/chat'
      fullPath: '/servers/$id/chat'
      preLoaderRoute: typeof AuthServersIdChatRouteImport
      parentRoute: typeof AuthServersIdRouteRoute
    }
    '/_auth/servers/$id/claude': {
      id: '/_auth/servers/$id/claude'
      path: '/claude'
      fullPath: '/servers/$id/claude'
      preLoaderRoute: typeof AuthServersIdClaudeRouteImport
      parentRoute: typeof AuthServersIdRouteRoute
    }
    '/_auth/servers/$id/graph': {
      id: '/_auth/servers/$id/graph'
      path: '/graph'
      fullPath: '/servers/$id/graph'
      preLoaderRoute: typeof AuthServersIdGraphRouteImport
      parentRoute: typeof AuthServersIdRouteRoute
    }
    '/_auth/servers/$id/inbox': {
      id: '/_auth/servers/$id/inbox'
      path: '/inbox'
      fullPath: '/servers/$id/inbox'
      preLoaderRoute: typeof AuthServersIdInboxRouteImport
      parentRoute: typeof AuthServersIdRouteRoute
    }
    '/_auth/servers/$id/people': {
      id: '/_auth/servers/$id/people'
      path: '/people'
      fullPath: '/servers/$id/people'
      preLoaderRoute: typeof AuthServersIdPeopleRouteImport
      parentRoute: typeof AuthServersIdRouteRoute
    }
    '/_auth/servers/$id/projects': {
      id: '/_auth/servers/$id/projects'
      path: '/projects'
      fullPath: '/servers/$id/projects'
      preLoaderRoute: typeof AuthServersIdProjectsRouteImport
      parentRoute: typeof AuthServersIdRouteRoute
    }
    '/_auth/servers/$id/questions': {
      id: '/_auth/servers/$id/questions'
      path: '/questions'
      fullPath: '/servers/$id/questions'
      preLoaderRoute: typeof AuthServersIdQuestionsRouteImport
      parentRoute: typeof AuthServersIdRouteRoute
    }
    '/_auth/servers/$id/server': {
      id: '/_auth/servers/$id/server'
      path: '/server'
      fullPath: '/servers/$id/server'
      preLoaderRoute: typeof AuthServersIdServerRouteImport
      parentRoute: typeof AuthServersIdRouteRoute
    }
    '/_auth/servers/$id/sources': {
      id: '/_auth/servers/$id/sources'
      path: '/sources'
      fullPath: '/servers/$id/sources'
      preLoaderRoute: typeof AuthServersIdSourcesRouteImport
      parentRoute: typeof AuthServersIdRouteRoute
    }
    '/_auth/servers/$id/suggestions': {
      id: '/_auth/servers/$id/suggestions'
      path: '/suggestions'
      fullPath: '/servers/$id/suggestions'
      preLoaderRoute: typeof AuthServersIdSuggestionsRouteImport
      parentRoute: typeof AuthServersIdRouteRoute
    }
    '/_auth/servers/$id/workflow': {
      id: '/_auth/servers/$id/workflow'
      path: '/workflow'
      fullPath: '/servers/$id/workflow'
      preLoaderRoute: typeof AuthServersIdWorkflowRouteImport
      parentRoute: typeof AuthServersIdRouteRoute
    }
    '/_auth/servers/$id/runs/$rid': {
      id: '/_auth/servers/$id/runs/$rid'
      path: '/runs/$rid'
      fullPath: '/servers/$id/runs/$rid'
      preLoaderRoute: typeof AuthServersIdRunsRidRouteImport
      parentRoute: typeof AuthServersIdRouteRoute
    }
    '/_auth/servers/$id/tasks/$key': {
      id: '/_auth/servers/$id/tasks/$key'
      path: '/tasks/$key'
      fullPath: '/servers/$id/tasks/$key'
      preLoaderRoute: typeof AuthServersIdTasksKeyRouteImport
      parentRoute: typeof AuthServersIdRouteRoute
    }
  }
}

interface AuthServersIdRouteRouteChildren {
  AuthServersIdActivityRoute: typeof AuthServersIdActivityRoute
  AuthServersIdChatRoute: typeof AuthServersIdChatRoute
  AuthServersIdClaudeRoute: typeof AuthServersIdClaudeRoute
  AuthServersIdGraphRoute: typeof AuthServersIdGraphRoute
  AuthServersIdInboxRoute: typeof AuthServersIdInboxRoute
  AuthServersIdPeopleRoute: typeof AuthServersIdPeopleRoute
  AuthServersIdProjectsRoute: typeof AuthServersIdProjectsRoute
  AuthServersIdQuestionsRoute: typeof AuthServersIdQuestionsRoute
  AuthServersIdServerRoute: typeof AuthServersIdServerRoute
  AuthServersIdSourcesRoute: typeof AuthServersIdSourcesRoute
  AuthServersIdSuggestionsRoute: typeof AuthServersIdSuggestionsRoute
  AuthServersIdWorkflowRoute: typeof AuthServersIdWorkflowRoute
  AuthServersIdIndexRoute: typeof AuthServersIdIndexRoute
  AuthServersIdRunsRidRoute: typeof AuthServersIdRunsRidRoute
  AuthServersIdTasksKeyRoute: typeof AuthServersIdTasksKeyRoute
}

const AuthServersIdRouteRouteChildren: AuthServersIdRouteRouteChildren = {
  AuthServersIdActivityRoute: AuthServersIdActivityRoute,
  AuthServersIdChatRoute: AuthServersIdChatRoute,
  AuthServersIdClaudeRoute: AuthServersIdClaudeRoute,
  AuthServersIdGraphRoute: AuthServersIdGraphRoute,
  AuthServersIdInboxRoute: AuthServersIdInboxRoute,
  AuthServersIdPeopleRoute: AuthServersIdPeopleRoute,
  AuthServersIdProjectsRoute: AuthServersIdProjectsRoute,
  AuthServersIdQuestionsRoute: AuthServersIdQuestionsRoute,
  AuthServersIdServerRoute: AuthServersIdServerRoute,
  AuthServersIdSourcesRoute: AuthServersIdSourcesRoute,
  AuthServersIdSuggestionsRoute: AuthServersIdSuggestionsRoute,
  AuthServersIdWorkflowRoute: AuthServersIdWorkflowRoute,
  AuthServersIdIndexRoute: AuthServersIdIndexRoute,
  AuthServersIdRunsRidRoute: AuthServersIdRunsRidRoute,
  AuthServersIdTasksKeyRoute: AuthServersIdTasksKeyRoute,
}

const AuthServersIdRouteRouteWithChildren =
  AuthServersIdRouteRoute._addFileChildren(AuthServersIdRouteRouteChildren)

interface AuthRouteRouteChildren {
  AuthAdminRoute: typeof AuthAdminRoute
  AuthPlaneRoute: typeof AuthPlaneRoute
  AuthTokensRoute: typeof AuthTokensRoute
  AuthServersIdRouteRoute: typeof AuthServersIdRouteRouteWithChildren
  AuthServersNewRoute: typeof AuthServersNewRoute
  AuthServersIndexRoute: typeof AuthServersIndexRoute
}

const AuthRouteRouteChildren: AuthRouteRouteChildren = {
  AuthAdminRoute: AuthAdminRoute,
  AuthPlaneRoute: AuthPlaneRoute,
  AuthTokensRoute: AuthTokensRoute,
  AuthServersIdRouteRoute: AuthServersIdRouteRouteWithChildren,
  AuthServersNewRoute: AuthServersNewRoute,
  AuthServersIndexRoute: AuthServersIndexRoute,
}

const AuthRouteRouteWithChildren = AuthRouteRoute._addFileChildren(
  AuthRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRouteRoute: AuthRouteRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
